import logo from "@/assets/placeholder-logo.png";

export function BrandLogo({ className }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className ?? ""}`}>
      <img src={logo} alt="Dev-Hub" className="h-8 w-auto shrink-0 object-contain" />
      <div className="hidden sm:flex flex-col leading-none">
        <span className="text-[11px] font-semibold tracking-widest text-muted-foreground uppercase">
          dev-hub
        </span>
        <span className="text-sm font-semibold text-foreground">Dashboard</span>
      </div>
    </div>
  );
}
